import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getConfiguracionesCaso3,
  getConfiguracionesCaso3Bis,
  updateConfiguracionesCaso3,
  insertConfiguracionesCaso3,
  deleteConfiguracionesCaso3Bis,
  updateConfiguracionesCaso3Bis,
  insertConfiguracionesCaso3Bis,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CONFIGURACIONES_CASO3() {
  try {
    const caso3Data = yield call(getConfiguracionesCaso3)
    if (caso3Data.ok) {
      yield put({
        type: actions.CONFIGURACIONES_CASO3_LOAD_SUCCEEDED,
        payload: caso3Data.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar configuraciones caso 3')
      put({
        type: actions.CONFIGURACIONES_CASO3_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CONFIGURACIONES_CASO3_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_CONFIGURACIONES_CASO3_BIS() {
  try {
    const caso3BisData = yield call(getConfiguracionesCaso3Bis)
    if (caso3BisData.ok) {
      yield put({
        type: actions.CONFIGURACIONES_CASO3_BIS_LOAD_SUCCEEDED,
        payload: caso3BisData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar configuraciones caso 3 bis')
      put({
        type: actions.CONFIGURACIONES_CASO3_BIS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CONFIGURACIONES_CASO3_BIS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CONFIGURACIONES_CASO3(action) {
  try {
    const caso3Obj = yield call(updateConfiguracionesCaso3, action.payload)
    if (caso3Obj.ok) {
      putMessage(messageType.SUCCESS, 'Configuración Caso 3 Bis correctamente')
      yield put({
        type: actions.CONFIGURACION_CASO3_UPDATE_SUCCEEDED,
        payload: caso3Obj.data,
      })
      if (action.payload.resetFechaLimite) {
        yield put({
          type: actions.CONFIGURACIONES_CASO3_BIS_LOAD_REQUESTED,
        })
      }
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Configuración Caso 3 Bis')
      yield put({
        type: actions.CONFIGURACION_CASO3_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Configuración Caso 3 Bis')
    yield all([
      put({
        type: actions.CONFIGURACION_CASO3_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CONFIGURACIONES_CASO3(action) {
  try {
    const caso3BisObj = yield call(insertConfiguracionesCaso3, action.payload)
    if (caso3BisObj.ok) {
      putMessage(messageType.SUCCESS, 'Configuración Caso 3 Bis creada correctamente')
      yield put({
        type: actions.CONFIGURACION_CASO3_INSERT_SUCCEEDED,
        payload: caso3BisObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Configuración Caso 3 Bis')
      yield put({
        type: actions.CONFIGURACION_CASO3_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Configuración Caso 3 Bis')
    yield all([
      put({
        type: actions.CONFIGURACION_CASO3_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CONFIGURACIONES_CASO3_BIS(action) {
  try {
    const caso3BisObj = yield call(insertConfiguracionesCaso3Bis, action.payload)
    if (caso3BisObj.ok) {
      putMessage(messageType.SUCCESS, 'Configuración Caso 3 Bis creada correctamente')
      yield put({
        type: actions.CONFIGURACION_CASO3_BIS_INSERT_SUCCEEDED,
        payload: caso3BisObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Configuración Caso 3 Bis')
      yield put({
        type: actions.CONFIGURACION_CASO3_BIS_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Configuración Caso 3 Bis')
    yield all([
      put({
        type: actions.CONFIGURACION_CASO3_BIS_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CONFIGURACIONES_CASO3_BIS(action) {
  try {
    const caso3bisResult = yield call(deleteConfiguracionesCaso3Bis, action.payload)
    if (caso3bisResult.ok) {
      putMessage(messageType.SUCCESS, 'Configuración Caso 3 Bis eliminada correctamente')
      yield put({
        type: actions.CONFIGURACION_CASO3_BIS_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Configuración Caso 3 Bis')
      yield put({
        type: actions.CONFIGURACION_CASO3_BIS_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Configuración Caso 3 Bis')
    yield all([
      put({
        type: actions.CONFIGURACION_CASO3_BIS_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CONFIGURACIONES_CASO3_BIS(action) {
  try {
    const caso3BisObj = yield call(updateConfiguracionesCaso3Bis, action.payload)
    if (caso3BisObj.ok) {
      putMessage(messageType.SUCCESS, 'Configuración Caso 3 Bis correctamente')
      yield put({
        type: actions.CONFIGURACION_CASO3_BIS_UPDATE_SUCCEEDED,
        payload: caso3BisObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Configuración Caso 3 Bis')
      yield put({
        type: actions.CONFIGURACION_CASO3_BIS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Configuración Caso 3 Bis')
    yield all([
      put({
        type: actions.CONFIGURACION_CASO3_BIS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CONFIGURACIONES_CASO3_LOAD_REQUESTED, GET_CONFIGURACIONES_CASO3),
    takeEvery(actions.CONFIGURACIONES_CASO3_BIS_LOAD_REQUESTED, GET_CONFIGURACIONES_CASO3_BIS),
    takeEvery(actions.CONFIGURACION_CASO3_UPDATE_REQUESTED, UPDATE_CONFIGURACIONES_CASO3),
    takeEvery(actions.CONFIGURACION_CASO3_INSERT_REQUESTED, INSERT_CONFIGURACIONES_CASO3),
    takeEvery(actions.CONFIGURACION_CASO3_BIS_INSERT_REQUESTED, INSERT_CONFIGURACIONES_CASO3_BIS),
    takeEvery(actions.CONFIGURACION_CASO3_BIS_DELETE_REQUESTED, DELETE_CONFIGURACIONES_CASO3_BIS),
    takeEvery(actions.CONFIGURACION_CASO3_BIS_UPDATE_REQUESTED, UPDATE_CONFIGURACIONES_CASO3_BIS),
  ])
}
